module.exports = __webpack_public_path__ + "static/media/bg_TC.5114fd84.jpg";